import { render, staticRenderFns } from "./work_edit.vue?vue&type=template&id=3d01f63e&scoped=true&"
import script from "./work_edit.vue?vue&type=script&lang=js&"
export * from "./work_edit.vue?vue&type=script&lang=js&"
import style0 from "./work_edit.vue?vue&type=style&index=0&id=3d01f63e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01f63e",
  null
  
)

export default component.exports